
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nyskraning",
      function () {
        return require("private-next-pages/nyskraning.tsx");
      }
    ]);
  